import escConfig from '../config';
import constants from '../constants';

const LOCAL_STORAGE_API_KEY = constants.LOCAL_STORAGE_KEY.api;
const LOCAL_STORAGE_SOCKET_KEY = constants.LOCAL_STORAGE_KEY.socket;
let API: string = localStorage.getItem(LOCAL_STORAGE_API_KEY) || '';
let SOCKET_API = localStorage.getItem(LOCAL_STORAGE_SOCKET_KEY);

export const envAPI: string = escConfig.API_URL || '';
export const envSocketAPI: string = escConfig.SOCKET_URL || '';

export const loadInital = async () => {
  const api = await localStorage.getItem(LOCAL_STORAGE_API_KEY);
  const socket_api = await localStorage.getItem(LOCAL_STORAGE_SOCKET_KEY);
  if (socket_api) {
    SOCKET_API = socket_api;
  } else {
    SOCKET_API = envSocketAPI;
  }

  if (api) {
    API = api;
  } else {
    API = envAPI;
  }
  return API;
};

export const changeAPI = async (endpoint: string) => {
  if (endpoint) {
    API = endpoint;
    await localStorage.setItem(LOCAL_STORAGE_API_KEY, endpoint);
  }
  return API;
};
export const setDefaultEnvApi = () => {
  API = envAPI;
};

export const getAPI = () => {
  API = localStorage.getItem(LOCAL_STORAGE_API_KEY) || '';
  return API || envAPI;
};
export const getSocketAPI = () => {
  SOCKET_API = localStorage.getItem(LOCAL_STORAGE_SOCKET_KEY) || '';
  return SOCKET_API || envSocketAPI;
};
